import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DemoApiClient } from './demo-api.client';
import {
  DemoDatabaseMigration,
  DemoDatabaseOverview,
  DemoDatabaseResetResult,
  DemoDatabaseSeed,
  DemoDatabaseTable,
  DemoDatabaseTableContent,
} from './database-admin.models';

@Injectable({ providedIn: 'root' })
export class DemoDatabaseAdminService {
  private readonly api = inject(DemoApiClient);

  overview(): Observable<DemoDatabaseOverview> {
    return this.api.get<DemoDatabaseOverview>('/api/admin/database');
  }

  tables(): Observable<{ readonly data: readonly DemoDatabaseTable[] }> {
    return this.api.get<{ readonly data: readonly DemoDatabaseTable[] }>(
      '/api/admin/database/tables',
    );
  }

  tableContent(
    tableName: string,
    page = 1,
    pageSize = 50,
  ): Observable<DemoDatabaseTableContent> {
    return this.api.get<DemoDatabaseTableContent>(
      `/api/admin/database/tables/${encodeURIComponent(tableName)}`,
      { page, pageSize },
    );
  }

  migrations(): Observable<{
    readonly data: readonly DemoDatabaseMigration[];
  }> {
    return this.api.get<{
      readonly data: readonly DemoDatabaseMigration[];
    }>('/api/admin/database/migrations');
  }

  seeds(): Observable<{ readonly data: readonly DemoDatabaseSeed[] }> {
    return this.api.get<{ readonly data: readonly DemoDatabaseSeed[] }>(
      '/api/admin/database/seeds',
    );
  }

  reset(): Observable<DemoDatabaseResetResult> {
    return this.api.post<DemoDatabaseResetResult>(
      '/api/admin/database/reset',
      { confirm: true },
    );
  }
}
